import { httpClient } from './httpClient';
import { Organisation } from '../../types/organization';
import { logger } from '../../utils/logger';

interface OrganisationResponse {
  items: Organisation[];
}

export const organizationApi = {
  async listOrganisations() {
    try {
      const response = await httpClient.get<OrganisationResponse>('/organisations');
      return response.data?.items ?? [];
    } catch (error) {
      logger.error('Failed to fetch organizations:', error);
      throw error;
    }
  },
  async clientOrganisations(clientId: string) {
    try {
      const response = await httpClient.get<OrganisationResponse>(`/organisations/${clientId}`);
      return response.data.items;
    } catch (error) {
      logger.error('Failed to fetch organizations:', error);
      throw error;
    }
  },
};
